import { useEffect } from 'react';
import { useApiClient } from '../../shared/providers/AppDataProvider.js';
import { useTenantCode } from '../../shared/tenant/TenantProvider.js';
import { isPlatformChromeTenant } from '../../app/platformChromeTenant.js';
import { useCustomerSession } from '../../shared/session/CustomerSessionProvider.js';
import { usePlatformAccountMemberships } from '../account/accountApi.js';
import { hydrateServerConsentFromClient } from './consentPromotion.js';
import { useLoyaltyProfilingAvailable } from './useLoyaltyProfilingAvailable.js';
import { registerConsentPromotionHandler } from '../../shared/consent/consentPromotionRegistry.js';

export { registerConsentPromotionHandler, triggerConsentPromotion } from '../../shared/consent/consentPromotionRegistry.js';

/** Runs R15 server hydration inside AppDataProvider (session provider sits above it). */
export function ConsentPromotionBridge(): null {
  const api = useApiClient();
  const tenantCode = useTenantCode();
  const { session } = useCustomerSession();
  const { loyaltyProfilingAvailable } = useLoyaltyProfilingAvailable();
  const memberships = usePlatformAccountMemberships(
    session !== null && isPlatformChromeTenant(tenantCode),
  );

  useEffect(() => {
    return registerConsentPromotionHandler((session) => {
      // Pass browse tenant; hydrate remaps `__platform__` → jwt home after
      // establishSession.writeJwtTenantCode (same synchronous turn).
      void hydrateServerConsentFromClient({
        tenantCode,
        customerId: session.customerId,
        authToken: null,
        api,
        loyaltyProfilingAvailable,
        memberships: memberships.data?.memberships,
      });
    });
  }, [
    api,
    loyaltyProfilingAvailable,
    memberships.data?.memberships,
    tenantCode,
  ]);

  return null;
}
